import { jsPDF } from 'jspdf';

/** A4 paysage : zone utile plus large qu’en portrait (210 mm → 297 mm de large). */
export const PDF_DOCUMENT_PAGE_WIDTH_MM = 297;
export const PDF_DOCUMENT_PAGE_HEIGHT_MM = 210;

/** Options de base partagées (html2canvas + extensions). */
export interface Html2CanvasDocumentExportOptions {
    scale: number;
    useCORS: boolean;
    backgroundColor: string;
    width: number;
    height: number;
    logging: boolean;
    allowTaint: boolean;
    scrollX: number;
    scrollY: number;
    windowWidth: number;
    windowHeight: number;
}

/**
 * Options html2canvas alignées sur `ApproveVenteComponent.downloadPDF` (bouton PDF de la parametre-bar).
 * À utiliser avec tout élément DOM à capturer (aperçu écran ou conteneur hors écran).
 */
export function getHtml2CanvasOptionsForDocumentExport(element: HTMLElement): Html2CanvasDocumentExportOptions {
    const w = element.scrollWidth;
    const h = element.scrollHeight;
    return {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        width: w,
        height: h,
        logging: false,
        allowTaint: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: w,
        windowHeight: h
    };
}

/**
 * Convertit un canvas en PDF A4 paysage avec découpe multi-pages (même logique partout).
 */
export function saveCanvasAsPdfDocument(canvas: HTMLCanvasElement, filename: string): void {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('l', 'mm', 'a4');
    const imgWidth = PDF_DOCUMENT_PAGE_WIDTH_MM;
    const pageHeight = PDF_DOCUMENT_PAGE_HEIGHT_MM;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
    while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
    }
    pdf.save(filename);
}
